const User = () => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(1 1)"
      >
        <path d="M16 18v-2c0-2.21-1.79-4-4-4H4c-2.21 0-4 1.79-4 4v2" />
        <circle cx="8" cy="4" r="4" />
      </g>
    </svg>
  );
};

export { User };
